import axios from 'axios';

/**
 * Centralized translation of payment-api errors (deposit / withdraw) into
 * user-facing strings. Both forms previously duplicated this try/catch
 * over the mutation `onError` handler; centralizing keeps the messaging
 * consistent and adds a single place to extend (e.g. 422 with field-level
 * detail, 429 with retry-after).
 */
export function parsePaymentApiError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    // No response = transport failure. Surfaces both true network outages
    // and CORS/preflight failures consistently.
    if (!err.response) {
      return 'Network error. Check your connection and try again.';
    }

    const status = err.response.status;
    const message = (err.response.data as { message?: string | string[] } | undefined)?.message;
    const reason = Array.isArray(message) ? message[0] : message;

    if ((status === 400 || status === 404 || status === 422) && reason) {
      return reason;
    }
    if (status === 401) {
      return 'Please sign in to continue.';
    }
    if (status === 403) {
      return "You don't have permission to do that.";
    }
    if (status === 429) {
      return 'Too many requests. Try again shortly.';
    }
    if (status >= 500) {
      return 'Something went wrong on our end. Please try again.';
    }
  }
  return 'Something went wrong. Please try again.';
}
